module.exports = __webpack_public_path__ + "static/media/school.49f06a53.svg";